const getDisplayTextWithLengthLimit = (text, limit) => {
  if (!text || text.length <= limit) {
    return text;
  }

  return `${text.substring(0, limit).trim()}...`;
};

export default getDisplayTextWithLengthLimit;
